<template>
  <div class="container-fluid">
    <div class="chart-page">
      <div class="card mb-2">
        <div class="card-body" style="text-align: -webkit-center">
          <div class="chart-title mb-2">使用者登入紀錄</div>
          <apexchart
            type="bar"
            width="500"
            height="450"
            :options="chartOptions"
            :series="series"
          />
        </div>
      </div>

      <div class="card search-card">
        <div class="card-body">
          <div class="form-row">
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">部門</label>
                <treeselect
                  :multiple="true"
                  :options="departmentOptions"
                  :searchable="true"
                  :show-count="true"
                  :default-expand-level="1"
                  placeholder="請選擇"
                  v-model="searchCondition.DepartmentGuids"
                >
                  <label
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                    :class="labelClassName"
                    for=""
                  >
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">
                      ({{ count }})
                    </span>
                  </label>
                </treeselect>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">使用者</label>
                <el-input
                  clearable=""
                  placeholder="請輸入關鍵字（姓名、帳號、手機）"
                  v-model.trim="searchCondition.Keyword"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <button
                type="button"
                class="btn btn-primary"
                @click="getLoginRecord(), (currentPage = 1)"
              >
                查詢
              </button>
              <button
                type="button"
                class="btn btn-info"
                @click="loginRecordDownload"
              >
                匯出報表
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap" style="padding: 20px">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="DepartmentName" label="部門"> </el-table-column>
        <el-table-column prop="Name" label="使用者"> </el-table-column>
        <el-table-column label="登入時間">
          <template slot-scope="scope">
            <span>{{ $common.dateFormatter(scope.row.CreateTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="pageSize"
      layout="sizes, prev, pager, next"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";

export default {
  name: "LoginRecord",

  data() {
    return {
      // 查詢條件
      dateRange: [],
      searchCondition: {},
      departmentOptions: [],

      // 圖表
      chartOptions: {
        xaxis: {
          categories: [],
        },
        yaxis: {},
      },
      series: [
        {
          name: "數量",
          data: [],
        },
      ],

      // 分頁
      tableData: [],
      totalData: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },

  methods: {
    // 取得 登入紀錄資料
    getLoginRecord() {
      this.updateLoading(true);
      this.$api.userLogin
        .getUserLoginRecord({
          StartDate: this.dateRange[0],
          EndDate: this.dateRange[1],
          ...this.searchCondition,
          IsPaging: true,
          Page: this.currentPage,
          PerPage: this.pageSize,
        })
        .then((response) => {
          if (response.status === 200) {
            this.tableData = response.data.AdminUserLoginRecordDtos;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 取得 登入紀錄圖表
    getLoginChart() {
      this.updateLoading(true);
      this.$api.userLogin
        .getUserLoginChart({
          StartDate: this.dateRange[0],
          EndDate: this.dateRange[1],
          TopRanking: 10,
        })
        .then((response) => {
          if (response.status === 200) {
            this.chartOptions = {
              xaxis: {
                categories: response.data.categories,
              },
              yaxis: {
                max: response.data.max,
                min: response.data.min,
                tickAmount: response.data.tickAmount,
              },
            };
            this.series = [
              {
                name: "登入紀錄",
                data: response.data.data,
              },
            ];
          }
          this.updateLoading(false);
        });
    },

    // 匯出 登入紀錄（excel）
    loginRecordDownload() {
      this.updateLoading(true);
      this.$api.userLogin
        .downloadUserLoginRecord({
          StartDate: this.dateRange[0],
          EndDate: this.dateRange[1],
          ...this.searchCondition,
        })
        .then((response) => {
          if (response.status === 200) {
            let fileName = decodeURIComponent(
              decodeURIComponent(
                response.headers["content-disposition"].split(
                  "filename*=UTF-8''"
                )[1]
              )
            );
            this.updateLoading(false);
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    },

    // 一頁顯示幾筆資料
    handleSizeChange(val) {
      this.pageSize = val;
      this.getLoginRecord();
    },

    // 換頁
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getLoginRecord();
    },

    async getData() {
      // 取得 部門選項
      const department = await this.$api.department.getDepartment();
      this.departmentOptions = department.data;
      this.dateRange = [this.$common.getLastMonth(), this.$common.getToday()];
      await this.getLoginChart();
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.btn {
  margin-top: 30px;
  margin-left: 10px;
}
</style>
